/*!
devtools-detect
https://github.com/sindresorhus/devtools-detect
By Sindre Sorhus
MIT License
*/
var devtools = {
  isOpen: false,
  orientation: undefined
};
var threshold = 160;

var emitEvent = function emitEvent(isOpen, orientation) {
  globalThis.dispatchEvent(new globalThis.CustomEvent('devtoolschange', {
    detail: {
      isOpen: isOpen,
      orientation: orientation
    }
  }));
};

var main = function main() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$emitEvents = _ref.emitEvents,
      emitEvents = _ref$emitEvents === void 0 ? true : _ref$emitEvents;

  var widthThreshold = globalThis.outerWidth - globalThis.innerWidth > threshold;
  var heightThreshold = globalThis.outerHeight - globalThis.innerHeight > threshold;
  var orientation = widthThreshold ? 'vertical' : 'horizontal';

  if (!(heightThreshold && widthThreshold) && (globalThis.Firebug && globalThis.Firebug.chrome && globalThis.Firebug.chrome.isInitialized || widthThreshold || heightThreshold)) {
    if ((!devtools.isOpen || devtools.orientation !== orientation) && emitEvents) {
      emitEvent(true, orientation);
    }

    devtools.isOpen = true;
    devtools.orientation = orientation;
  } else {
    if (devtools.isOpen && emitEvents) {
      emitEvent(false, undefined);
    }

    devtools.isOpen = false;
    devtools.orientation = undefined;
  }
};

main({
  emitEvents: false
});
setInterval(main, 500);
export default devtools;